import { c as _c } from "react/compiler-runtime";
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { GET_JOYBIRD_INSTAGRAM_IMAGES } from 'mocks/queries';
import useSuspenseQuery from 'commons/useSuspenseQuery';
const InstagramImages = t0 => {
  const $ = _c(3);
  const {
    render
  } = t0;
  const {
    data,
    error,
    loading
  } = useSuspenseQuery(GET_JOYBIRD_INSTAGRAM_IMAGES);
  if (loading || !data) {
    return null;
  }
  if (error) {
    return `Error!: ${error}`;
  }
  let t1;
  if ($[0] !== data || $[1] !== render) {
    t1 = render({
      config: {
        images: get(data, "getJoybirdInstagramImages.images", [])
      }
    });
    $[0] = data;
    $[1] = render;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
InstagramImages.propTypes = {
  render: PropTypes.func.isRequired
};
export default InstagramImages;